import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/spotium-ikone/ikona_rampa.svg'


const _hoisted_1 = { class: "h-fit w-full rounded-md border border-gray-300 bg-white p-4 duration-300 ease-in-out hover:shadow-lg" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex w-full items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-20",
    src: _imports_0
  })
], -1)
const _hoisted_3 = { class: "my-8 font-medium" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "flex items-center justify-center space-x-3" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "flex w-full items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.resource?.assignment?.name), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'clock-rotate-left'] }),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.triggerTime), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.isOpenButtonDisplayed)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 0,
            size: "full",
            "is-loading": _ctx.isSubmitLoading,
            text: `${_ctx.resource?.device?.data?.type === 1 ? 'Open' : 'Open/Close'}`,
            "button-type": "primaryButton",
            onClick: _ctx.triggerResource
          }, null, 8, ["is-loading", "text", "onClick"]))
        : (_openBlock(), _createBlock(_component_the_button, {
            key: 1,
            size: "full",
            "is-disabled": true,
            "is-loading": _ctx.isSubmitLoading,
            "button-type": "primaryButton",
            variant: "ghost",
            text: "No permission to open",
            onClick: _ctx.triggerResource
          }, null, 8, ["is-loading", "onClick"]))
    ])
  ]))
}